import {depositCosts} from "./custom/depositCosts";
import {loadPrices, replaceZeroPrices} from "./custom/loadBeturboPrices";
import {beturboDirectOrder} from "./custom/directOrder";
import {warranties} from "./custom/warranties";
import {initInputBody} from "cronus-theme/default/global/js/inputfile";
import {replaceItemno, getReplacebleItemNo} from "./custom/replaceItemno";
import {phoneCountryField} from "./custom/phoneCountryField";
import {externalStock, basketStock} from "./custom/externalStock";
import {logSearchRequest} from "./custom/enhancedSearchTracking"

beturboDirectOrder();
depositCosts();
externalStock();
loadPrices();
replaceZeroPrices();
warranties();
initInputBody();
replaceItemno();
phoneCountryField();
logSearchRequest();

document.addEventListener("updateBasketViews", function () {
    replaceZeroPrices();
    basketStock();
});
window.getReplacebleItemNo = getReplacebleItemNo;